module.exports = __webpack_public_path__ + "img/R.72e61a57.jpg";